import React, { createContext, useContext, useState } from 'react';

const ProductSelectedContext = createContext(undefined);

let setProductSelectedGlobal = () => { };

export const ProductSelectedProvider = ({ children }) => {
    const [productSelected, setProductSelected] = useState('');

    setProductSelectedGlobal = setProductSelected;

    return (
        <ProductSelectedContext.Provider value={{ productSelected, setProductSelected }}>
            {children}
        </ProductSelectedContext.Provider>
    );
};

export const useProduct = () => {
    const context = useContext(ProductSelectedContext);
    if (!context) throw new Error('useProduct deve ser usado dentro de ProductSelectedProvider');
    return context;
};

export const setGlobalProduct = (state) => {
    setProductSelectedGlobal(state);
};
